import { render, staticRenderFns } from "./trainingHeader.vue?vue&type=template&id=a85b9c36&scoped=true&"
import script from "./trainingHeader.vue?vue&type=script&lang=js&"
export * from "./trainingHeader.vue?vue&type=script&lang=js&"
import style0 from "./trainingHeader.vue?vue&type=style&index=0&id=a85b9c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85b9c36",
  null
  
)

export default component.exports